/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewSnippetDefinition } from '../models/new-snippet-definition';
import { SnippetDefinition } from '../models/snippet-definition';
import { SnippetDefinitionPartial } from '../models/snippet-definition-partial';
import { SnippetDefinitionWithRelations } from '../models/snippet-definition-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class SnippetDefinitionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation snippetDefinitionControllerCreateAsTemplate
   */
  static readonly SnippetDefinitionControllerCreateAsTemplatePath = '/admin/snippet-definitions/save-as-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAsTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAsTemplate$Response(params?: {
    body?: NewSnippetDefinition
  }): Observable<StrictHttpResponse<SnippetDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerCreateAsTemplatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SnippetDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAsTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAsTemplate(params?: {
    body?: NewSnippetDefinition
  }): Observable<SnippetDefinition> {

    return this.createAsTemplate$Response(params).pipe(
      map((r: StrictHttpResponse<SnippetDefinition>) => r.body as SnippetDefinition)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerCount
   */
  static readonly SnippetDefinitionControllerCountPath = '/snippet-definitions/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerFindById
   */
  static readonly SnippetDefinitionControllerFindByIdPath = '/snippet-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<SnippetDefinitionWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SnippetDefinitionWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<SnippetDefinitionWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<SnippetDefinitionWithRelations>) => r.body as SnippetDefinitionWithRelations)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerDeleteById
   */
  static readonly SnippetDefinitionControllerDeleteByIdPath = '/snippet-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerUpdateById
   */
  static readonly SnippetDefinitionControllerUpdateByIdPath = '/snippet-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: SnippetDefinitionPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: SnippetDefinitionPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerFind
   */
  static readonly SnippetDefinitionControllerFindPath = '/snippet-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<SnippetDefinitionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SnippetDefinitionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<SnippetDefinitionWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SnippetDefinitionWithRelations>>) => r.body as Array<SnippetDefinitionWithRelations>)
    );
  }

  /**
   * Path part for operation snippetDefinitionControllerCreate
   */
  static readonly SnippetDefinitionControllerCreatePath = '/snippet-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewSnippetDefinition
  }): Observable<StrictHttpResponse<SnippetDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, SnippetDefinitionControllerService.SnippetDefinitionControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SnippetDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewSnippetDefinition
  }): Observable<SnippetDefinition> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<SnippetDefinition>) => r.body as SnippetDefinition)
    );
  }

}
